import setHtmlAttributeAsKeyValuePair from "@Utils/setHtmlAttributeAsKeyValuePair";
import FiltersType from "@Pages/reviews/types/Filters.type";
import {Dispatch, SetStateAction} from "react";

export default function getInputFieldUpdateHandler(setFilters: Dispatch<SetStateAction<FiltersType>>) {
    const handleInputFieldUpdate = (e) => {
        const updatedValues = setHtmlAttributeAsKeyValuePair(e, 'name')
        setFilters((prevFilters) => (
            {
                ...prevFilters,
                ...updatedValues,
            }
        ))
    }

    return handleInputFieldUpdate
}